'use client'
import { dynamicEvents } from '../../../../events/dynamicEvents.js';
import { logger } from '../../../logger.js';

class SessionStorage {
    static getDynamicSSKey(key) {
        return `${key}${SessionStorage.getSuffix()}`;
    }
    static setSuffix(localStorageSuffix) {
        if (!SessionStorage.__suffix__) {
            const suffix = (localStorageSuffix && `_${localStorageSuffix}`) || '';
            SessionStorage.__suffix__ = suffix;
        }
    }
    /**
     *
     * @param key
     * @returns
     */
    static getItem(key) {
        if (typeof window === 'undefined') {
            return undefined;
        }
        const value = window.sessionStorage.getItem(SessionStorage.getDynamicSSKey(key));
        if (!value) {
            return undefined;
        }
        try {
            return JSON.parse(value);
        }
        catch (error) {
            logger.debug(`Error while parsing ${key} from session storage`, {
                value,
            });
            SessionStorage.removeItem(key);
            dynamicEvents.emit('triggerLogout');
        }
        return undefined;
    }
    static removeItem(key) {
        if (typeof window === 'undefined') {
            return undefined;
        }
        return window.sessionStorage.removeItem(SessionStorage.getDynamicSSKey(key));
    }
    /**
     *
     * @param key
     * @param value
     * @returns
     */
    static setItem(key, value) {
        if (typeof window === 'undefined') {
            return;
        }
        window.sessionStorage.setItem(SessionStorage.getDynamicSSKey(key), JSON.stringify(value));
    }
    static getKeys() {
        if (typeof window === 'undefined') {
            return [];
        }
        return Object.keys(window.sessionStorage);
    }
}
SessionStorage.getSuffix = () => SessionStorage.__suffix__ || '';

export { SessionStorage, SessionStorage as default };
